import { useState } from 'react'
import { useFieldArray, useFormContext } from 'react-hook-form'

import { IconName } from 'ui/components'
import { IconButton } from 'ui/components/Buttons'
import { useConfirmation } from 'ui/hooks'
import { Col, FormRow } from 'ui/themes/globalStyles'
import { SarEdit } from '~bank-bsa-reporting/types'

import { PhoneExt } from './PhoneExt'
import { PhoneNumber } from './PhoneNumber'
import { PhoneType } from './PhoneType'

export const Phone = ({ index }: { index: number }) => {
  const { control } = useFormContext<SarEdit>()

  const { fields, append, remove } = useFieldArray({
    control,
    name: `subjectsInfo.${index as 0}.phoneNumbers`
  })

  const [itemToRemove, setItemToRemove] = useState<number | null>(null)

  const { open: startDeleting, Confirmation } = useConfirmation({
    message: `Are you sure you want to remove this item?`,
    onConfirm: () => itemToRemove !== null && remove(itemToRemove),
    confirmationButtonText: 'Delete',
    isConfirmationNegative: true
  })

  return (
    <>
      <Confirmation />
      <FormRow>
        <Col>
          <h5>Phone (s)</h5>
        </Col>
      </FormRow>

      {fields.map((field, index2) => (
        <div key={field.id} style={{ marginBottom: '15px' }}>
          <FormRow>
            <Col>
              <PhoneNumber index1={index} index2={index2} />
            </Col>
            <Col>
              <PhoneExt index1={index} index2={index2} />
            </Col>
          </FormRow>
          <FormRow>
            <Col>
              <PhoneType index1={index} index2={index2} />
            </Col>
            {fields.length > 1 && (
              <IconButton
                face="negative"
                icon={IconName.DELETE}
                onClick={() => {
                  setItemToRemove(index2)
                  startDeleting()
                }}
              />
            )}
          </FormRow>
        </div>
      ))}

      <IconButton
        icon={IconName.ADD_GREEN}
        onClick={() => append({ phoneNumber: '', phoneExt: '', phoneType: '' })}
        style={{ marginBottom: '15px' }}
      />
    </>
  )
}
